import React from 'react';
import Row from './Row';
import Pagination from './Pagination';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './style.css';
import { useProvideGrid, GridContext } from './state';
import HeaderCell from './HeaderCell';

function Grid({
    columns = [],
    data = [],
    maxRows,
    page,
    tableClassName = '',
    className = '',
    // sortHandler,
    usePagination = false,
    events = {},
    rowSelect = false,
    initialState
}) {

    const { state, ...dispatch } = useProvideGrid({ data, page, maxRows, initialState, columns });

    const {
        currentPage
    } = state;

    return (
        <GridContext.Provider value={{ state, dispatch, events, page, maxRows }} >
            <section className={cx(className, 'flex', 'flex-col', 'items-stretch', 'justify-center')}>
                <table className={cx(tableClassName, 'flex-1')}>
                    <thead>
                        <tr>
                            {state.columns.map((x, i) => <HeaderCell column={x} key={i} />)}
                        </tr>
                    </thead>
                    <tbody>
                        {currentPage?.length > 0 ? (
                            currentPage.map((item, index) => (
                                <Row
                                    key={`tr-${index}`}
                                    rowIndex={index}
                                    data={item}
                                    columns={columns}
                                    selected={rowSelect && state.selectedRow == index}
                                    selectRow={() => {
                                        dispatch.selectRow(index);
                                    }}
                                    onRowClick={events.onRowClick}
                                />
                            ))
                        ) : (
                            <tr>
                                <td className="alert alert-light" colSpan={columns.length}>No records found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {usePagination && (<Pagination className='mt-auto' />)}
            </section>
        </GridContext.Provider>
    );
}

Grid.propTypes = {
    data: PropTypes.array,
    maxRows: PropTypes.number,
    page: PropTypes.number,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
            title: PropTypes.string,
            field: PropTypes.string,
            width: PropTypes.number,
            cell: PropTypes.func,
            cellProps: PropTypes.object,
            sorter: PropTypes.func
        })
    ),
    rowIndex: PropTypes.number,
    rowSelect: PropTypes.bool,
    onRowClick: PropTypes.func,
    sortHandler: PropTypes.func,
    className: PropTypes.string,
    tableClassName: PropTypes.string,
    usePagination: PropTypes.bool,
    dataSize: PropTypes.number,
    events: PropTypes.shape({
        onRowClick: PropTypes.func,
        onPageChange: PropTypes.func,
        onPageSizeChange: PropTypes.func
    }),
    initialState: PropTypes.shape({
        defaultPageSize: PropTypes.number,
        pageIndex: PropTypes.number,
        currentPage: PropTypes.arrayOf(PropTypes.any),
        selectedRow: PropTypes.number,
        sort: PropTypes.shape({
            column: PropTypes.string,
            order: PropTypes.string
        })
    })
};

export default Grid;